'use client';!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();

import { createContext, ReactNode, useContext } from 'react'

/**
 * Values the client is allowed to know about authentication.
 */
type ClientAuth = { isAuthenticated: boolean }

const AuthenticationContext = createContext<ClientAuth | undefined>(undefined)

export function AuthenticationProvider({
  children,
  isAuthenticated,
}: { children: ReactNode } & ClientAuth) {
  return (
    <AuthenticationContext.Provider value={{ isAuthenticated }}>
      {children}
    </AuthenticationContext.Provider>
  )
}

export function useAuthentication() {
  const context = useContext(AuthenticationContext)
  if (context === undefined) {
    throw new Error(
      'useAuthentication must be used within an AuthenticationProvider.',
    )
  }
  return context
}
